export default __webpack_public_path__ + "04e76a2faabe8343d8f42376c95ccb47.png";